import { Box, Flex } from "@chakra-ui/react"
import React from "react"
import CustomImage from "../../../../../shared/CustomImage"

type Props = {
  images: string[]
  mainImage: string
  setMainImage: (image: string) => void
  hideContainerHighlight?: () => void
}

const ThumbnailsRow = ({ images, mainImage, setMainImage, hideContainerHighlight }: Props) => {
  const handleThumbnailClick = (e: React.MouseEvent<HTMLElement>, image: string) => {
    e.preventDefault()
    e.stopPropagation()

    if (hideContainerHighlight) hideContainerHighlight()

    setMainImage(image)
  }

  const thunmbnailsCount = images.length + 1

  return (
    <Box maxW="100%" overflowX="auto">
      <Flex w={thunmbnailsCount * 10}>
        {images.map((image: string) => {
          const isSelected = image === mainImage
          return (
            <Box
              key={image}
              border="1px solid"
              borderColor={isSelected ? "gray.900" : "transparent"}
              onClick={(e) => handleThumbnailClick(e, image)}
              _hover={!isSelected && { borderColor: "black", bg: "gray.200" }}
              cursor="pointer"
              zIndex="docked"
              p="1"
            >
              <CustomImage src={image} maxW="8" maxH="8" alt="Product image thumbnail" loading="eager" />
            </Box>
          )
        })}
      </Flex>
    </Box>
  )
}

export default ThumbnailsRow
